import { render, staticRenderFns } from "./DocumentTree.vue?vue&type=template&id=167c3fec&"
import script from "./DocumentTree.vue?vue&type=script&lang=ts&"
export * from "./DocumentTree.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentTree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports